var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title",style:({
    backgroundImage: 'url(' + "" + _vm.bgurl + ')',
    backgroundSize: (_vm.bgSize + "rem 0.41rem"),
  })},[_c('p',{staticClass:"en"},[_vm._v(_vm._s(_vm.titleInfo.titleEn))]),_vm._v(" "),_c('p',{staticClass:"cn",domProps:{"innerHTML":_vm._s(_vm.titleInfo.titleCn)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1672b226","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/titleBox.vue
// module id = null
// module chunks = 